module.exports = __webpack_public_path__ + "img/biwahonagoya_mo.4270eb38.jpg";